import axios from "axios";
const instanceAxios = axios.create();

const projectStage = process.env.REACT_APP_PROJECT_STAGE ? process.env.REACT_APP_PROJECT_STAGE : 'qa';
console.log("projectStage", process.env.REACT_APP_PROJECT_STAGE, projectStage)
const ENV_ENUM = {
    DEV : 'dev',
    QA  : 'qa',
    PROD: 'prod'
}
let BASE_URL = "";
let headers = {};
if (projectStage === ENV_ENUM.PROD) {
    BASE_URL = 'https://8quntm5h1h.execute-api.us-east-1.amazonaws.com/prod'
    headers = {
        'Accept': 'application/json',
        'Content-Type' : 'application/json',
        'x-api-key' : 'qh3n7uR2K4onzY6mabakB8FFQDqvgR9ZcGLFLzd0'
    }
} else {
    BASE_URL = 'https://x3qjml2vi9.execute-api.us-east-1.amazonaws.com/qa';
    headers = {
        'Accept': 'application/json',
        'Content-Type' : 'application/json'
    }
}

instanceAxios.defaults.baseURL = BASE_URL;
instanceAxios.defaults.headers = headers;

export default instanceAxios;